import api from './api';
import { authStorage } from '../utils/authStorage';

export interface User {
    id: string;
    email: string;
    role: string;
    first_name?: string;
    last_name?: string;
    restaurant_id?: string | number;
    employees?: any[];
    partners?: any;
    permissions?: string[];
    plan_features?: string[];
}

export interface AuthResponse {
    status: string;
    data: {
        token: string;
        user: User;
    };
}

export const authService = {
    login: async (email: string, password: string): Promise<AuthResponse> => {
        const response = await api.post<AuthResponse>('/auth/login', { email, password });
        return response.data;
    },

    getProfile: async (): Promise<{ status: string; data: { user: User } }> => {
        const response = await api.get('/users/me');
        return response.data;
    },

    logout: () => {
        authStorage.clearCurrentTab();
    }
};
